export const categoryGroupIdByX = (x, list) => {
    return Object.keys(list).reduce((acc, itemId) => {
        let item = list[itemId];
        if (! item.category_group) return acc;
        if (! acc[item.category_group.id]) acc[item.category_group.id] = [];
        acc[item.category_group.id].push(item[x]);
        return acc;
    }, {})
}

export const categoryByX = (x, list) => {
    return Object.keys(list).reduce((acc, itemId) => {
        let item = list[itemId];
        acc[item[x]] = item;
        return acc;
    }, {})
}
